module.exports = __webpack_public_path__ + "static/img/4.15fc3c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technical/4.png
// module id = oW7q
// module chunks = 1